/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Page_Find_TitleInputs */

const en_how_page_find_title = /** @type {(inputs: How_Page_Find_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find someone nearby.`)
};

const pl_how_page_find_title = /** @type {(inputs: How_Page_Find_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Znajdź kogoś w okolicy.`)
};

/**
* | output |
* | --- |
* | "Find someone nearby." |
*
* @param {How_Page_Find_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const how_page_find_title = /** @type {((inputs?: How_Page_Find_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Page_Find_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_how_page_find_title(inputs)
	return en_how_page_find_title(inputs)
});